module.exports = __webpack_public_path__ + "static/media/cloud-backup.ec4955ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector/cloud-backup.svg
// module id = 287
// module chunks = 0